import React, { FC } from "react";
import {
  AppTextField,
  AppInput,
  AppModal,
  AppFormErrorText,
} from "../../theme";
import t from "../../localization/en/translation.json";
import { lookupModel } from "../../containers/createProject/lookupModel";
import { validateFormInputForSpecialChar } from "../../utils/helper-utility";
import "./adminTypesModal.scss";

interface IProps {
  isOpen: boolean;
  onClose: Function;
  onConfirm: Function;
  onUpdateDescription: Function;
  selectedType: lookupModel | null;
  description: string;
}

const AdminTypesModal: FC<IProps> = ({
  isOpen,
  onClose,
  onConfirm,
  selectedType,
  onUpdateDescription,
  description,
}) => {
  const renderRegionName = () => (
    <div className="admin-types-modal-input">
      <AppInput
        value={selectedType ? selectedType.name : ""}
        autoComplete="off"
        label={t.admin_type_modal_name}
        disabled
      />
    </div>
  );

  const renderRegionDescription = () => (
    <div className="admin-types-modal-textarea">
      <AppTextField
        maxLength={250}
        value={description}
        label={t.admin_type_modal_desc}
        onChange={({ target }) => onUpdateDescription(target.value)}
      />
      {validateFormInputForSpecialChar(description) && (
        <AppFormErrorText>
          {t.all_ssp_validate_special_character_in_text_error.replace(
            "{1}",
            description.trim().split("")[0]
          )}
        </AppFormErrorText>
      )}
    </div>
  );

  return (
    <AppModal
      size="md"
      showModal={isOpen}
      onModalClose={() => onClose()}
      onConfirm={() => onConfirm({ ...selectedType, description })}
      cancelBtnText={t.cancel}
      confirmBtnText={t.edit_project_update}
      title={t.admin_type_modal_title}
      disabledValue={validateFormInputForSpecialChar(description)}
    >
      <div className="admin-types-modal-content">
        {renderRegionName()}
        {renderRegionDescription()}
      </div>
    </AppModal>
  );
};

export default AdminTypesModal;
